module.exports = __webpack_public_path__ + "static/media/cartIcon_orange.bf7e0d71.png";